export function isEqualToOrOlderThanToday(utcString) {
  // Parse the UTC datetime string
  const utcDate = new Date(utcString);

  // Normalize the given UTC datetime to local midnight
  const givenLocalDate = new Date(
    utcDate.getFullYear(),
    utcDate.getMonth(),
    utcDate.getDate()
  );

  // Normalize today's local date to midnight
  const today = new Date();
  const todayLocalDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );

  // Check if given date is equal to or before today
  return givenLocalDate <= todayLocalDate;
}
